import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  fetchSpendAggregation,
  spendAggregationQueryKey,
  type SpendAggregationQuery,
} from '@/features/transactions/spendAggregation';

export type { SpendAggregationQuery } from '@/features/transactions/spendAggregation';
export { spendAggregationQueryKey } from '@/features/transactions/spendAggregation';

export interface UseSpendByCategoryParams {
  accountIds?: readonly string[];
  dateFrom?: string;
  dateTo?: string;
  cursor?: string | null;
  enabled?: boolean;
}

export function useSpendByCategory(params: UseSpendByCategoryParams = {}) {
  const query: SpendAggregationQuery = {
    mode: 'category',
    accountIds: params.accountIds ?? [],
    dateFrom: params.dateFrom,
    dateTo: params.dateTo,
    cursor: params.cursor,
  };

  return useQuery({
    queryKey: spendAggregationQueryKey(query),
    enabled: params.enabled ?? true,
    retry: false,
    placeholderData: keepPreviousData,
    queryFn: () => fetchSpendAggregation(query),
  });
}

export default useSpendByCategory;
